/* eslint-disable prefer-rest-params */
import {isTest} from '../../../libs/shared/helpers/src/environment/envHelpers';
import {ErrorWithData} from '../../../libs/shared/helpers/src/types/customErrors';
import {reportToBugsnag} from '../../../srcCommon/services/bugsnag/bugsnag';

// From https://github.com/facebook/react/issues/11538#issuecomment-417504600
export function setupNodeFunctionMonitors() {
  // You wouldn't want those errors to be swallowed when writing tests.
  if (isTest()) {
    return;
  }

  if (typeof Node === 'function' && Node.prototype) {
    const originalRemoveChild = Node.prototype.removeChild;
    // @ts-expect-error
    Node.prototype.removeChild = function removeChild(child) {
      if (child.parentNode !== this) {
        reportToBugsnag(
          new ErrorWithData(`Failed to execute 'removeChild' on 'Node'`, {
            node: describeNode(this),
            child: describeNode(child),
          }),
        );
        return child;
      }

      return originalRemoveChild.apply(this, arguments as any);
    };

    const originalInsertBefore = Node.prototype.insertBefore;
    // @ts-expect-error
    Node.prototype.insertBefore = function removeChild(newNode, referenceNode) {
      if (referenceNode && referenceNode.parentNode !== this) {
        reportToBugsnag(
          new ErrorWithData(`Failed to execute 'insertBefore' on 'Node'`, {
            node: describeNode(this),
            newNode: describeNode(newNode),
            referenceNode: describeNode(referenceNode),
          }),
        );

        return newNode;
      }

      return originalInsertBefore.apply(this, arguments as any);
    };
  }
}

/**
 * DOM nodes may contain sensitive information, so we only include essential information for debugging
 */
function describeNode(node?: Node) {
  if (!node) {
    return node;
  }

  if (isElement(node)) {
    return `<${node.tagName} id="${encAttrValue(node.id)}" class="${encAttrValue(node.className)}" ...>`;
  }

  return `${node.nodeName}`;
}

function isElement(node: Node): node is Element {
  return node.nodeType === Node.ELEMENT_NODE;
}

function encAttrValue(value: string) {
  const attrEntities: {[key: string]: string} = {
    '&': '&amp;',
    '"': '&quot;',
    '\u00a0': '&nbsp;',
  };

  return value.replace(/&\u00a0"/g, (char) => attrEntities[char]);
}
